module.exports = {"profile":{"certificates":{"headline":"Awards and Certificates","emptyText":"Show what you have learned and mastered."}}}